
import SuperSecuritySettings from "../components/superadmin/SecuritySettings";

export default function SuperSettings() {
  return (
    <div>
      <SuperSecuritySettings />
    </div>
  );
}
